module.exports = __webpack_public_path__ + "static/logo-white-76caf0221a0985ec07570fd4c51f69e9.png";